module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('principal-header', {
    ref: "headerMenu"
  }), _vm._v(" "), (_vm.loginUser) ? _c('div', {
    staticClass: "row"
  }, [_c('section', [(!_vm.collapsed) ? _c('div', [_c('div', {
    staticClass: "find-job col-md-2"
  }, [_c('div', {
    attrs: {
      "id": "sidebar-container"
    }
  }, [_c('sidebar-menu', {
    attrs: {
      "menu": _vm.menu,
      "collapsed": _vm.collapsed,
      "theme": _vm.selectedTheme,
      "show-one-child": true
    },
    on: {
      "toggle-collapse": _vm.onToggleCollapse,
      "item-click": _vm.onItemClick
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "find-job col-md-10"
  }, [_c('router-view')], 1)]) : _c('div', [_c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    attrs: {
      "id": "sidebar-container"
    }
  }, [_c('sidebar-menu', {
    attrs: {
      "menu": _vm.menu,
      "collapsed": _vm.collapsed,
      "theme": _vm.selectedTheme,
      "show-one-child": true
    },
    on: {
      "toggle-collapse": _vm.onToggleCollapse,
      "item-click": _vm.onItemClick
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('router-view')], 1)])])]) : _c('div', [_c('section', [_c('router-view')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-341c66ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/empleador/menu.vue
// module id = 645
// module chunks = 1